import { Allocation } from './allocation';
import * as Enumerable from 'linq';
import { LexoRank } from '../shared/lexorank';
import { Run, RunTemplateEntity } from './run';

export class RunUtility {

    public static getRunOrder(allocations: Allocation[], insertedId: string, insertedIndex: number) {

        allocations = allocations?.filter(x => x._id != insertedId);

        const first = Enumerable.from(allocations).firstOrDefault();
        const last = Enumerable.from(allocations).lastOrDefault();

        if (!first || !last) {
            return LexoRank.first().toString();
        }

        if (!allocations?.length) {

            const lex = LexoRank.first().toString();
            return lex;

        } else if (insertedIndex == 0) {

            const lex = first?.runOrder
                ? LexoRank.from(first?.runOrder).decrement().toString()
                : LexoRank.first().toString();

            return lex;

        } else if (insertedIndex == allocations.length) {

            const lex = last?.runOrder
                ? LexoRank.from(last?.runOrder).increment().toString()
                : LexoRank.first().toString();

            return lex;

        } else {

            const previous = allocations[insertedIndex - 1];
            const next = allocations[insertedIndex];

            const lex = LexoRank.between(previous?.runOrder, next?.runOrder).toString();

            return lex;
        }

    }

    public static getRunTemplateEntity(run: Run): RunTemplateEntity {
        return {
            _id: run._id,
            name: run.name,
            resources: run.resources,
            start: {
                name: run?.start?.name,
                description: run?.start?.description,
                address: run?.start?.address,
            },
            finish: {
                name: run?.finish?.name,
                description: run?.finish?.description,
                address: run?.finish?.address,
            }
        };
    }
}